export default __webpack_public_path__ + "static/media/greyDot.99843cc8.svg";